import { BaseService } from "../base-service";
import { API_BASE_URL } from "../../config";
import type { LcrOrder } from "./lcr-order.types";

const LCR_ORDERS_PATH = "/v1/orders/lcr";

export class LcrOrdersService extends BaseService {
  constructor() {
    super(API_BASE_URL);
  }

  public getMyLcrOrders(): Promise<LcrOrder[]> {
    return this.getJson<LcrOrder[]>(LCR_ORDERS_PATH);
  }

  public getLcrOrder(serialNumber: string): Promise<LcrOrder> {
    return this.getJson<LcrOrder>(`${LCR_ORDERS_PATH}/${encodeURIComponent(serialNumber)}`);
  }

  private async getJson<T>(path: string): Promise<T> {
    const response = await this.fetch(path);
    if (!response.ok) {
      throw new Error(`LCR orders API error: ${response.status}`);
    }
    return await response.json();
  }
}
